import {JsonProperty} from '@hyperloris/tyson';
import {ReportProfile} from "./report-profile";
import {TableRecordResult} from "../api/table-record-result";
import {FieldRecord} from "../api/field-record";

export class ProfileTableRecordResult extends TableRecordResult<ReportProfile> {

  @JsonProperty()
  recordTypes : FieldRecord<any>[];

}

